class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.listItem = this.closest('.header__inline-menu li');
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
    this.closeTimeout = null;

    this.onListItemMouseEnter = this.onListItemMouseEnter.bind(this);
    this.onListItemMouseLeave = this.onListItemMouseLeave.bind(this);

    if (this.listItem) {
      this.hoverMediaQuery.addEventListener('change', this.bindHoverEvents.bind(this));
      this.bindHoverEvents();
    }
  }

  bindHoverEvents() {
    if (!this.listItem) return;

    this.listItem.removeEventListener('mouseenter', this.onListItemMouseEnter);
    this.listItem.removeEventListener('mouseleave', this.onListItemMouseLeave);

    if (!this.hoverMediaQuery.matches) return;

    this.listItem.addEventListener('mouseenter', this.onListItemMouseEnter);
    this.listItem.addEventListener('mouseleave', this.onListItemMouseLeave);
  }

  onListItemMouseEnter() {
    window.clearTimeout(this.closeTimeout);
    this.closeSiblingMenus();
    this.openMenu();
  }

  onListItemMouseLeave(event) {
    if (this.listItem.contains(event.relatedTarget)) return;

    this.closeTimeout = window.setTimeout(() => {
      this.close();
    }, 120);
  }

  closeSiblingMenus() {
    if (!this.listItem?.parentElement) return;

    this.listItem.parentElement.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;
      menu.close();
    });
  }

  openMenu() {
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
